export default {
    name: 'Titan des marrées',
    boostOneShot: {
        lv1: 1,
        lv2: 2,
        lv3: 7,
        lv4: NaN,
        lv5: NaN
    },
    oneShot: {
        lv1: 2,
        lv2: 5,
        lv3: 17,
        lv4: NaN,
        lv5: NaN
    },
    boostOneByOne: {
        lv1: 1,
        lv2: 2,
        lv3: NaN,
        lv4: NaN,
        lv5: NaN
    },
    oneByOne: {
        lv1: 2,
        lv2: 4,
        lv3: NaN,
        lv4: NaN,
        lv5: NaN
    }
};
